// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"836aa657","331":"3447831d","387":"0e5d93e9","581":"c48f8bfe","935":"cb0e7929"}[chunkId] + ".chunk.js";
};